import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

interface ThreadActionConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  processing: boolean;
  destructive?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ThreadActionConfirmationDialog = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  processing,
  destructive = false,
  onCancel,
  onConfirm,
}: ThreadActionConfirmationDialogProps) => (
  <Dialog
    open={open}
    onClose={processing ? undefined : onCancel}
    fullWidth
    maxWidth="sm"
  >
    <DialogTitle>{title}</DialogTitle>

    <DialogContent dividers>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="outlined" disabled={processing} onClick={onCancel}>
        {cancelLabel}
      </Button>

      <Button
        variant="contained"
        color={destructive ? 'secondary' : 'primary'}
        disabled={processing}
        onClick={onConfirm}
        startIcon={
          processing ? (
            <CircularProgress size={16} color="inherit" />
          ) : undefined
        }
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ThreadActionConfirmationDialog;
